import React, { useState, useEffect, useRef, useContext, Fragment } from "react";
import Colorer from 'color';
import {
 SketchPicker,
 AlphaPicker,
 BlockPicker,
 ChromePicker,
 CirclePicker,
 CompactPicker,
 GithubPicker,
 HuePicker,
 MaterialPicker,
 PhotoshopPicker,
 SliderPicker,
 SwatchesPicker,
 TwitterPicker,
} from "react-color";
import { ProductContext } from "../context";
import ColorRandomizer from "../sb/ColorRandomizer";
import ColorThemer from "../sb/ColorThemer";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Pill,
  Button,
  Breadcrumbs,
  Slider,
  Head,
  Card,
  Input,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification,
  ContentBlock
} from "xsolla-uikit";
import { SbSizer } from './SbSizer';

// import CustomPicker from "../sb/SbColorInput";





export default function StoreSbColor ({
  height = 44,
  changeOneAtt = false, //if false, changes all colors
  type,
  target = 'global',
}) {


  const [state, setState] = useState();

  const changeTheme = useContext(ProductContext).changeTheme;
  const oldTheme = useContext(ProductContext).getTheme();




  useEffect(() => {

    if (!state && oldTheme[changeOneAtt] !== state) {
      setState(oldTheme[changeOneAtt])
    }
    // setLight(Colorer(oldTheme[changeOneAtt]).luminosity() * 100)

  }, [oldTheme])


const [timer, setTimer] = useState()

  useEffect(() => {
    // if (!timer) {
    //     setTimer(setTimeout(() => {
    //       if (state !== oldTheme[changeOneAtt]) {
    //       let newTheme = {}
    //       newTheme = Object.assign(newTheme, oldTheme);
    //       newTheme[changeOneAtt] = state;
    //       changeTheme(target, newTheme);
    //     }
    //   }, 10))}
    // return () => setTimer(clearTimeout(timer));

    if (state !== oldTheme[changeOneAtt]) {
      let newTheme = {}
      newTheme = Object.assign(newTheme, oldTheme);
      newTheme[changeOneAtt] = state;
      changeTheme(target, newTheme);
    }


  }, [state])




  useEffect(() => {

    if (changeOneAtt && oldTheme[changeOneAtt] !== state) {
      setState(oldTheme[changeOneAtt])
    }
    // if (oldTheme[changeOneAtt] !== )



  }, [changeOneAtt])



  useEffect(() => {
    return () => {
      setState(oldTheme[changeOneAtt]);
    };
  }, [changeOneAtt]);


  const [light, setLight] = useState(50);

  const changeLightness = (newVal) => {
  //  console.log('newVal = ', newVal);
    setLight(newVal)
  }
  const changeRadius = (newVal) => {
    let newTheme = {}
    newTheme = Object.assign(newTheme, oldTheme);
    newTheme['borderRadius'] = newVal;
    changeTheme('global', newTheme)
  }




  const [tempColor, setTempColor] = useState()

  useEffect(() => {
    let newTheme = {}
    newTheme = Object.assign(newTheme, oldTheme);


    // // prevTheme[changeOneAtt]
    // console.log('light/100 = ', light/100);
    // if(Colorer(tempColor).lighten(light/100/2).hex() !== Colorer(newTheme[changeOneAtt]).lighten(light/100/2).hex()) {
    //   setTempColor(newTheme[changeOneAtt]);
    //   newTheme[changeOneAtt] = Colorer(newTheme[changeOneAtt]).lighten(light/100/2).hex();
    // //  console.log('1 = ', newTheme[changeOneAtt]);
    // } else {
    //   newTheme[changeOneAtt] = Colorer(tempColor).lighten(light/100/2).hex();
    // //  console.log('2 = ', newTheme[changeOneAtt]);
    // }

    // changeTheme(newTheme);
    // newTheme[changeOneAtt] = Colorer(oldTheme[changeOneAtt]).lighten(light / 10).hex();
  }, [light]);



  return (
    <Fragment>
    {/* <div style={{width: '100%',}}> */}

        {type === 'picker' && <SketchPicker
          color={state}
          onChange={newColor => {
            setState(newColor.hex);

            if (changeOneAtt) {
              let newTheme = {}
              newTheme = Object.assign(newTheme, oldTheme);
              newTheme[changeOneAtt] = newColor.hex;
              changeTheme(target, newTheme);
            } else {
              changeTheme(ColorThemer(target, oldTheme, newColor.hex));
            }
          }}
        />}

        {type === 'slider' && <SliderPicker
        color={state}
        onChange={newColor => {
          setState(newColor.hex);

          if (changeOneAtt) {
            let newTheme = {}
              newTheme = Object.assign(newTheme, oldTheme);
              newTheme[changeOneAtt] = newColor.hex;
              changeTheme(target, newTheme);
          } else {
            changeTheme(target, ColorThemer(oldTheme, newColor.hex));
          }
        }}
        />}

        {type === 'hue' && <div style={{
          transform:'scale(0.75) translateX(-40px)',
          }}
          key={`input_hue`}
          >
            <HuePicker
            style={{padding: 0}}
            color={state}
            onChange={newColor => {
              setState(newColor.hex);

              if (changeOneAtt) {
                let newTheme = {}
                  newTheme = Object.assign(newTheme, oldTheme);
                  newTheme[changeOneAtt] = newColor.hex;
                  changeTheme(target, newTheme);
              } else {
                changeTheme(target, ColorThemer(oldTheme, newColor.hex));
              }
            }}
          />
        </div>}

        {/* {type === 'input' && <input
          className='xsb_but_link_input'
          value={state}
        />} */}

        {type === 'input' &&
        <div className="">
        <Input
          key={`input_size`}
          size='md'
          disabled
          // focused= {(!index) ?  true : false}
          input={{
            name: `Color`,

            value: state || '',
            // onChange: this.setValueGeneralName
            onChange: ()=>void(0)
        }} /></div>}


        {/* {type === 'range' && <SbSizer
          key={`slider_range`}
          min={0}
          // type={'slider'}

          max={100}
          key={state}
          size='sm'
          // focused= {(!index) ?  true : false}
          input={{
            name: `Color`,

            value: light || null,
            onChange: changeLightness,
        }} />} */}

        {changeOneAtt === 'borderRadius' &&

        <SbSizer
          key={`slider_radius`}
          type='buttons'
          min={0}
          max={30}

          size='sm'
          // focused= {(!index) ?  true : false}
          input={{
            name: `borderRadius`,
            value: oldTheme['borderRadius'] || null,
            // onChange: changeRadius,
            onChange: nw => setState(nw),
        }} />

        }

        {changeOneAtt === 'paddings' && <SbSizer
          key={`slider_paddings`}
          min={4}

          max={24}
          size='sm'
          // focused= {(!index) ?  true : false}
          input={{
            name: `paddings`,
            value: state || null,
            // value: state,
            onChange: newRad => {
              setState(newRad)
            },
        }} />}


        {changeOneAtt === 'cardContrast' && <SbSizer
          key={`slider_contrast`}
          min={1}
          max={10}

          size='sm'
          // focused= {(!index) ?  true : false}
          input={{
            name: `cardContrast`,

            value: useContext(ProductContext).theme['cardContrast'],
            onChange: newRad => {
                setState(newRad);
            },
        }} />}


        {changeOneAtt === 'psWidth' && <SbSizer
          key={`slider_width`}
          min={520}
          max={800}

          size='sm'
          // focused= {(!index) ?  true : false}
          input={{
            name: `psWidth`,

            value: useContext(ProductContext).theme['psWidth'],
            onChange: newRad => {
                setState(newRad);
            },
        }} />}




        {type === 'random' && <ColorRandomizer height={height} target={target} />}



    {/* </div> */}
    </Fragment>
  );
}
